import type { AssessmentQuestion } from '@ts-assessment/interfaces'

import { AssessmentTopics } from '@ts-assessment/enums'

import imgQuestion1 from '@images/assessment/questions/ela/grade-k6/question-1.png'
import imgQuestion5 from '@images/assessment/questions/ela/grade-k6/question-5.png'
import imgQuestion11 from '@images/assessment/questions/ela/grade-k6/question-11.png'

export const questionsTest: AssessmentQuestion[] = [
  {
    name: 'grade_k6_1',
    title: 'You hear this sentence in a discussion:',
    topic: AssessmentTopics.ListeningAndSpeaking,
    detail: '"I understand your point, but I see it differently."',
    sentence: 'What does the speaker most likely want to do?',
    image: imgQuestion1,
    answers: [
      {
        name: 'grade_k6_1_a',
        text: 'End the conversation.',
      },
      {
        name: 'grade_k6_1_b',
        text: 'Agree completely.',
      },
      {
        name: 'grade_k6_1_c',
        text: 'Share their own opinion respectfully.',
        correct: true,
      },
    ],
  },
  {
    name: 'grade_k6_2',
    title: 'You hear these instructions:',
    topic: AssessmentTopics.ListeningAndSpeaking,
    detail: '"After you finish your worksheet, please pack up your materials quietly and wait for the next activity."',
    sentence: 'What should you do first?',
    answers: [
      {
        name: 'grade_k6_2_a',
        text: 'Pack up your materials.',
      },
      {
        name: 'grade_k6_2_b',
        text: 'Wait for the next activity.',
      },
      {
        name: 'grade_k6_2_c',
        text: 'Finish your worksheet.',
        correct: true,
      },
    ],
  },
  {
    name: 'grade_k6_3',
    title: 'Which of the following statements is an opinion?',
    topic: AssessmentTopics.ListeningAndSpeaking,
    answers: [
      {
        name: 'grade_k6_3_a',
        text: 'A square has four equal sides.',
      },
      {
        name: 'grade_k6_3_b',
        text: 'Reading books is more enjoyable than watching movies.',
        correct: true,
      },
      {
        name: 'grade_k6_3_c',
        text: 'The capital of France is Paris.',
      },
    ],
  },
  {
    name: 'grade_k6_4',
    title: 'Read the text:',
    topic: AssessmentTopics.ReadingAndUnderstanding,
    detail: '"Plastic bottles are convenient, but the environmental price is too high. If we don\'t switch to reusable containers now, future generations will inherit an ocean filled with more plastic than fish."',
    sentence: 'What is the author\'s primary warning?',
    answers: [
      {
        name: 'grade_k6_4_a',
        text: 'Plastic production is becoming more expensive every year.',
      },
      {
        name: 'grade_k6_4_b',
        text: 'The long-term damage to the ocean outweighs the short-term ease of using plastic.',
        correct: true,
      },
      {
        name: 'grade_k6_4_c',
        text: 'Future generations will need to find new ways to clean the ocean.',
      },
    ],
  },
  {
    name: 'grade_k6_5',
    title: 'Read the text:',
    topic: AssessmentTopics.ReadingAndUnderstanding,
    detail: '"Bees are essential pollinators in many ecosystems. They help plants reproduce by transferring pollen from one flower to another. Without bees, many fruits and vegetables would not grow, which would affect the food supply for both humans and animals."',
    sentence: 'What is the main idea of the passage?',
    image: imgQuestion5,
    answers: [
      {
        name: 'grade_k6_5_a',
        text: 'Bees make honey.',
      },
      {
        name: 'grade_k6_5_b',
        text: 'Bees play an important role in plant reproduction.',
        correct: true,
      },
      {
        name: 'grade_k6_5_c',
        text: 'Bees live in hives and work in groups.',
      },
    ],
  },
  {
    name: 'grade_k6_6',
    title: 'Read the text:',
    topic: AssessmentTopics.ReadingAndUnderstanding,
    detail: '"Electric cars use batteries instead of gasoline, which helps reduce air pollution. While they can be expensive to buy, they save owners money on fuel and repairs over time."',
    sentence: 'What is the best summary of this passage?',
    answers: [
      {
        name: 'grade_k6_6_a',
        text: 'Gasoline cars are much cheaper to buy than electric cars.',
      },
      {
        name: 'grade_k6_6_b',
        text: 'Batteries are the most important part of a modern vehicle.',
      },
      {
        name: 'grade_k6_6_c',
        text: 'Electric cars offer both environmental and long-term financial benefits.',
        correct: true,
      },
    ],
  },
  {
    name: 'grade_k6_7',
    title: 'Which sentence uses the active voice to make the writing more direct?',
    topic: AssessmentTopics.Writing,
    answers: [
      {
        name: 'grade_k6_7_a',
        text: 'The trophy was won by the most hardworking team.',
      },
      {
        name: 'grade_k6_7_b',
        text: 'The most hardworking team won the trophy.',
        correct: true,
      },
      {
        name: 'grade_k6_7_c',
        text: 'The winning of the trophy was done by the team.',
      },
    ],
  },
  {
    name: 'grade_k6_8',
    title: 'Which sentence uses punctuation correctly?',
    topic: AssessmentTopics.Writing,
    answers: [
      {
        name: 'grade_k6_8_a',
        text: 'She said "I will come tomorrow".',
      },
      {
        name: 'grade_k6_8_b',
        text: 'She said, "I will come tomorrow". ',
      },
      {
        name: 'grade_k6_8_c',
        text: 'She said, "I will come tomorrow."',
        correct: true,
      },
    ],
  },
  {
    name: 'grade_k6_9',
    title: 'Choose the word that best completes the sentence:',
    topic: AssessmentTopics.Writing,
    detail: 'The antique vase was so ______ that even a small vibration could cause it to shatter.',
    answers: [
      {
        name: 'grade_k6_9_a',
        text: 'weak',
      },
      {
        name: 'grade_k6_9_b',
        text: 'thin',
      },
      {
        name: 'grade_k6_9_c',
        text: 'fragile',
        correct: true,
      },
    ],
  },
  {
    name: 'grade_k6_10',
    title: 'Identify the abstract noun in the following sentence:',
    topic: AssessmentTopics.Language,
    detail: 'The explorers were filled with curiosity when they discovered the hidden cave.',
    answers: [
      {
        name: 'grade_k6_10_a',
        text: 'Explorers',
      },
      {
        name: 'grade_k6_10_b',
        text: 'Curiosity',
        correct: true,
      },
      {
        name: 'grade_k6_10_c',
        text: 'Cave',
      },
    ],
  },
  {
    name: 'grade_k6_11',
    title: 'Identify the adjective in this sentence: The tall building stood in the city center.',
    topic: AssessmentTopics.Language,
    image: imgQuestion11,
    answers: [
      {
        name: 'grade_k6_11_a',
        text: 'building',
      },
      {
        name: 'grade_k6_11_b',
        text: 'tall',
        correct: true,
      },
      {
        name: 'grade_k6_11_c',
        text: 'city',
      },
    ],
  },
  {
    name: 'grade_k6_12',
    title: 'Choose the sentence that is written as a complex sentence:',
    topic: AssessmentTopics.Language,
    answers: [
      {
        name: 'grade_k6_12_a',
        text: 'I wanted to go to the park, but it started to rain.',
      },
      {
        name: 'grade_k6_12_b',
        text: 'Because I forgot my lunch, I had to buy a sandwich at school.',
      },
      {
        name: 'grade_k6_12_c',
        text: 'Although I was tired, I finished my project, and then I went to sleep.',
        correct: true,
      },
    ],
  },
]
